<div [formGroup]="filterForm" class="form-content">
  <div class="pure-g">
    <!-- Row 1: Repair Code + Mode -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <app-aems-multiline-tag-input
        label="Repair Code"
        placeholder="Enter 4-digit repair code and press Enter"
        [regex]="repairCodeRegex"
        [transformToUppercase]="true"
        formControlName="RepairCodeDescriptionList">
      </app-aems-multiline-tag-input>
    </div>

    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-multi-select ngDefaultControl label="Mode" fit="medium" placeholder="Select modes" formControlName="RepairModeList">
        @for (mode of modeOptions; track mode) {
          <mc-option [value]="mode">{{ mode }}</mc-option>
        }
      </mc-multi-select>
    </div>
  </div>
</div>

<div class="utility-buttons">
  <mc-button
    label="Apply filters"
    variant="filled"
    appearance="primary"
    fit="medium"
    (click)="applyFilters()"
    (keydown.enter)="applyFilters()">
  </mc-button>
  <mc-button
    label="Clear filters"
    variant="outlined"
    appearance="neutral"
    fit="medium"
    class="m-r-8"
    (click)="clearFilters()"
    (keydown.enter)="clearFilters()">
  </mc-button>
</div>
